import { cn } from '@/shared/lib/cn';

type Tone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

const TONES: Record<Tone, string> = {
  neutral: 'bg-surface-hover text-fg-muted border-border',
  accent: 'bg-accent-subtle text-accent border-accent/30',
  success: 'bg-success-subtle text-success border-success/30',
  warning: 'bg-warning-subtle text-warning border-warning/30',
  danger: 'bg-danger-subtle text-danger border-danger/30',
  info: 'bg-info-subtle text-info border-info/30',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  icon?: React.ReactNode;
}

/**
 * Status badges always carry a text label, never colour alone — colour is not information
 * for a colour-blind or greyscale reader.
 */
export function Badge({ tone = 'neutral', icon, className, children, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        // max-w-full + ellipsis: a badge is a short label, so if one is ever long enough to
        // exceed its container it truncates rather than pushing the layout sideways.
        // shrink-0: but it is the *text beside it* that gives way first. Without it a flex row
        // squeezed the badge before a long title — "Đã hết hạn" cut to "Đã hế", "Mặc định" to
        // "Mặc đị" — because overflow-hidden lets a flex item shrink to nothing.
        'inline-flex max-w-full shrink-0 items-center gap-1 overflow-hidden text-ellipsis rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONES[tone],
        className,
      )}
      {...props}
    >
      {icon}
      {children}
    </span>
  );
}
